export const getUniqueKey = (data: Object): string => JSON.stringify(data);
